export default __webpack_public_path__ + "b6a1215d7e271cc93cc762b32e5d636c.webp";